import { Lock, Unlock, Plus, X } from "lucide-react";
import { useState } from "react";

export default function PagesEditor({
    pages = [],
    locked = false,
    onToggleLock,
    onChange
}) {
    const [newPage, setNewPage] = useState("");

    const normalizedPages = Array.isArray(pages) ? pages.filter(Boolean) : [];

    const addPage = () => {
        const value = newPage.trim();
        if (!value) return;

        const exists = normalizedPages.some(
            (page) => page.toLowerCase() === value.toLowerCase()
        );
        if (exists) {
            setNewPage("");
            return;
        }

        onChange([...normalizedPages, value]);
        setNewPage("");
    };

    const removePage = (pageToRemove) => {
        onChange(normalizedPages.filter((page) => page !== pageToRemove));
    };

    return (
        <div className="wpe-shell">
            <div className="wpe-head">
                <div>
                    <div className="wpe-title">Recommended Pages</div>
                    <div className="wpe-subtitle">
                        Add, remove, or lock page recommendations before generation.
                    </div>
                </div>

                <button
                    type="button"
                    className={`wg-lock-btn ${locked ? "locked" : ""}`}
                    onClick={onToggleLock}
                >
                    {locked ? <Lock size={14} /> : <Unlock size={14} />}
                    <span>{locked ? "Pages Locked" : "AI can update pages"}</span>
                </button>
            </div>

            <div className="wpe-chip-row">
                {normalizedPages.length > 0 ? (
                    normalizedPages.map((page) => (
                        <div key={page} className="wpe-chip">
                            <span>{page}</span>
                            <button
                                type="button"
                                className="wpe-chip-remove"
                                onClick={() => removePage(page)}
                            >
                                <X size={14} />
                            </button>
                        </div>
                    ))
                ) : (
                    <div className="wpe-empty">No pages selected yet.</div>
                )}
            </div>

            <div className="wpe-add-row">
                <input
                    type="text"
                    value={newPage}
                    onChange={(e) => setNewPage(e.target.value)}
                    placeholder="Add page e.g. Testimonials"
                />
                <button
                    type="button"
                    className="wg-secondary-btn"
                    onClick={addPage}
                >
                    <Plus size={14} />
                    Add Page
                </button>
            </div>
        </div>
    );
}